import React from "react";
import PropTypes from "prop-types";

import { useDraggable } from "components/DragDrop";

import { Icon, Loader } from "..";

export function FormLayout({
  loading,
  hideMenu,
  icon,
  children,
  popupMenu,
  actionIcons,
  disableHover,
}) {
  const { draggableProps, dragHandleProps } = useDraggable();

  return (
    <div
      className={disableHover ? "" : "grey_on_hover"}
      {...draggableProps}
      style={{
        display: "flex",
        flexDirection: "row",
        padding: "0.2em 0",
        alignItems: "baseline",
        ...draggableProps?.style,
      }}
    >
      <Icon
        {...dragHandleProps}
        data-test="form-layout-icon"
        name={icon}
        style={{
          marginRight: "0.6em",
          color: "#DADADA",
          fontSize: "14pt",
          flexBasis: 0,
        }}
      />
      <div style={{ flexGrow: 1 }}>{children}</div>
      {!loading && !hideMenu && actionIcons}
      {loading && (
        <Loader data-test="form-layout-loader" active inline size="tiny" />
      )}
      {!loading && !hideMenu && popupMenu && (
        <div style={{ marginLeft: "0.2em" }}>{popupMenu}</div>
      )}
    </div>
  );
}

FormLayout.propTypes = {
  icon: PropTypes.string,
  children: PropTypes.node,
  popupMenu: PropTypes.node,
  actionIcons: PropTypes.node,
  disableHover: PropTypes.bool,
  loading: PropTypes.bool,
  hideMenu: PropTypes.bool,
};

FormLayout.defaultProps = {
  disableHover: false,
  icon: "clipboard list",
  children: "Form",
  popupMenu: null,
  actionIcons: null,
  loading: false,
  hideMenu: false,
};

export default FormLayout;
